var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { media } from '../../styles';
var CardGrid = function (props) {
    return (_jsx(StyledCardGrid, __assign({ distribution: props.distribution }, { children: props.children })));
};
export default CardGrid;
var StyledCardGrid = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: grid;\n  gap: 1rem;\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  display: grid;\n  gap: 1rem;\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n"])), media.xlarge(templateObject_1 || (templateObject_1 = __makeTemplateObject(["gap: 2rem;"], ["gap: 2rem;"]))), media.small(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    grid-template-columns: ", "\n    "], ["\n    grid-template-columns: ", "\n    "])), function (props) {
    return props.distribution === 'grid' ? 'repeat(1, 1fr);' : 'auto';
}), media.medium(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    grid-template-columns: ", "\n    "], ["\n    grid-template-columns: ", "\n    "])), function (props) {
    return props.distribution === 'grid' ? 'repeat(2, 1fr);' : 'auto';
}), media.xlarge(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    grid-template-columns: ", "\n    "], ["\n    grid-template-columns: ", "\n    "])), function (props) {
    return props.distribution === 'grid' ? 'repeat(3, 1fr);' : 'auto';
}));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=CardGrid.js.map